import { useEffect } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import Navbar from "@/components/landing/Navbar";
import { ArrowLeft, Zap, Timer, Shield, TrendingUp, Cpu, Lock, FileText, GraduationCap } from "lucide-react";

const FEATURES = [
  { icon: Timer, title: "15–30 Second Rounds", desc: "Ultra-short binary options on crypto prices. Predict up or down and settle within seconds." },
  { icon: Zap, title: "AI-Assisted Signals", desc: "Optional real-time sentiment analysis on order books and trade flow to help read momentum." },
  { icon: Cpu, title: "Sub-100ms Execution", desc: "Off-chain C++ engine for near-instant matching, combined with on-chain settlement on Base." },
  { icon: Lock, title: "Non-Custodial", desc: "Your funds stay in smart contract vaults. No intermediary holds your assets." },
  { icon: TrendingUp, title: "100% Fee-to-Burn", desc: "All protocol trading fees flow to buyback-and-burn of $QVX. No inflationary emissions." },
  { icon: Shield, title: "Built on Base", desc: "Low gas, fast finality, and alignment with the Coinbase and Surge ecosystems." },
];

export default function OverviewPage() {
  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="min-h-screen" style={{ background: "#030406" }}>
      <Navbar />
      <div className="pt-24 pb-12 px-6 border-b border-white/5">
        <div className="max-w-4xl mx-auto">
          <Link to="/" className="font-mono text-xs text-slate-500 hover:text-[#00F0FF] transition-colors inline-flex items-center gap-1 mb-6">
            <ArrowLeft size={12} /> Back to home
          </Link>
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.6 }}>
            <span className="font-mono text-xs uppercase tracking-[0.2em] text-[#00F0FF] mb-3 block">DOCS / OVERVIEW</span>
            <h1 className="font-grotesk text-4xl sm:text-5xl font-bold text-white tracking-tight">What is Qovarix?</h1>
            <p className="font-grotesk text-lg text-slate-400 mt-4 max-w-2xl">
              Qovarix is a fast prediction market where users trade on whether crypto assets will go up or down in the next few seconds. Built for speed, simplicity, and non-custodial trading.
            </p>
          </motion.div>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-6 py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mb-16">
          {FEATURES.map((f, i) => {
            const Icon = f.icon;
            return (
              <motion.div key={f.title} className="glass-panel-active p-6" initial={{ opacity: 0, y: 15 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.4, delay: i * 0.08 }}>
                <Icon size={18} className="text-[#00F0FF] mb-3" strokeWidth={1.5} />
                <h3 className="font-grotesk text-base font-semibold text-white mb-2">{f.title}</h3>
                <p className="font-grotesk text-sm text-slate-400">{f.desc}</p>
              </motion.div>
            );
          })}
        </div>

        <div className="flex flex-wrap gap-4">
          <Link to="/docs/whitepaper" className="font-mono text-xs uppercase tracking-[0.15em] text-[#00F0FF] border border-[#00F0FF]/20 hover:border-[#00F0FF]/50 px-5 py-3 transition-colors inline-flex items-center gap-2">
            <FileText size={14} /> Read the Whitepaper
          </Link>
          <Link to="/docs/learn" className="font-mono text-xs uppercase tracking-[0.15em] text-slate-400 border border-white/10 hover:border-white/20 px-5 py-3 transition-colors inline-flex items-center gap-2">
            <GraduationCap size={14} /> Learn how to trade
          </Link>
        </div>
      </div>
    </div>
  );
}
